/*@ngInject*/
const UILocaleDirective = function (localization, $interpolate) {

    let linkFunction = function ($scope, $elm, $attr, controller, transclusionFn) {

        let key = null;

        transclusionFn($scope, function (clone) {
            let innerHtml = clone[0].nodeValue;

            if(innerHtml) {
                key = $interpolate(innerHtml)($scope);

                const translatedText = i18n.t(key);
                $elm.html(translatedText);
            }
        });

    };

    return {
        restrict: 'A',
        transclude: true,
        link: linkFunction
    };

};

angular.module('umCore')
    .directive('uiLocale', UILocaleDirective);
